const HalfDonutColors = ['#00C7FD', '#001965', '#EAAB00', '#F15C6B'];
const donutColors = ['#7B40EF', '#2AA4D5'];
const pieColors = ['#C9DD03', '#C7C2BA'];

export { HalfDonutColors, donutColors, pieColors };
